module.exports = "/dist/2f1aacc1587e8f78a21079f754850cc8.eot";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-roboto/files/roboto-latin-300italic.eot
// module id = 27
// module chunks = 0